module.exports = __webpack_public_path__ + "img/rod_role.bd7f59e6.png";